import apiRequestFunction from "~/api/request";
import type { ApiIndex } from "~/plugins/axios";

type RequestType = ReturnType<typeof apiRequestFunction>;

/**
 * Composable for accessing the API in Vue 3/Nuxt 3
 * This replaces the old useContext().$api pattern from Vue 2/Nuxt 2
 */
export function useApi(): ApiIndex {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$api as ApiIndex;
}

/**
 * Composable for accessing the Request in Vue 3/Nuxt 3
 * This replaces the old useContext().$Request pattern from Vue 2/Nuxt 2
 */
export function useRequest(): RequestType {
  const nuxtApp = useNuxtApp();
  return nuxtApp.$Request as RequestType;
}

export function useReq(): ApiIndex {
  const nuxtApp = useNuxtApp();

  return nuxtApp.$req as ApiIndex;
}
